import React from "react";

export default function SectionHeadingTitle({ content }) {
  return (
    <div className="sectionHeadingTitle">
      <h6 className="heading06">{content.subtitle}</h6>
      <h2 className="heading02">{content.title}</h2>
    </div>
  );
}
